import { WireCoverType } from 'scenes/common/api/quote/types';
import { WireFunnelType } from 'scenes/common/types';

export const toProductSubtype = (
  funnelType: WireFunnelType,
  coverType: WireCoverType
) => {
  const wireCoverType = coverType ? `:${coverType}` : '';
  return `${funnelType}${wireCoverType}`;
};
